<template>
  <component-wrapper
    :attribute="attribute"
    :attributeName="attributeName"
    :complete-required="completeRequired"
    :entityName="entityName"
    :helpText="helpText"
    :id="id"
    :label="label"
    :shouldRender="shouldRender"
    :required="!!ruleList.length"
    :showHeader="showHeader"
  >
    <template v-if="loading">
      <v-card class="mb-4" outlined>
        <v-row>
          <v-icon class="spinner mx-3" small width="10px">fa fa-spinner</v-icon>
          <p class="my-1">Loading options...</p></v-row
        ></v-card
      ></template
    >
    <v-autocomplete
      :chips="true"
      :data-cy="`${entityName}__selectFkMultiple--${attributeName}`"
      :deletable-chips="true"
      :disabled="disabled"
      :items="optionList"
      :filled="styleMap.filled"
      :loading="loading"
      :multiple="true"
      :outlined="styleMap.outlined"
      :placeholder="placeholder"
      :rules="ruleList"
      :solo="styleMap.solo"
      clearable
      color="primary"
      required
      v-else
      v-model="value"
    ></v-autocomplete>
  </component-wrapper>
</template>

<script>
import resolver from "../../../../../lib/resolver";

import userInputMixin from "./userInputMixin";

import ComponentWrapper from "./ComponentWrapper";

export default {
  components: {
    ComponentWrapper,
  },
  computed: {
    optionList() {
      if (!this.attribute.fkExists) {
        return ["No record reference set!"];
      }

      const optionList = this.optionListBase
        .map(entity => {
          entity.text = entity.readableText;
          entity.value = entity.id;
          return entity;
        })
        .sort((a, b) => {
          return a.text.toLowerCase() < b.text.toLowerCase() ? -1 : 1;
        });

      return optionList;
    },
  },
  async created() {
    this.value = this.castToArray(this.value);
    await this.getData();
  },
  data() {
    return {
      loading: false,
      optionListBase: [],
    };
  },
  methods: {
    async getData() {
      const { attribute } = this;
      this.loading = true;

      if (
        !attribute.fkExists ||
        !attribute.fkName ||
        (attribute.fkName === "option" &&
          (!attribute.fkType || !attribute.fkTypeValue))
      ) {
        this.optionListBase = [];
        this.loading = false;
        return;
      }

      await this.$store.dispatch("user/list", { reload: false });

      this.optionListBase = await resolver.getFkOptionList(this.attribute);

      if (this.attribute.fkTypeValue === "clarityState") {
        this.optionListBase = this.optionListBase.filter(
          option => parseInt(option.optionId, 10) < 52
        );
      }

      this.loading = false;
    },
    castFromArray(value) {
      if (!Array.isArray(value)) {
        return value;
      }
      return value[0];
    },
    castToArray(value) {
      if (Array.isArray(value)) {
        return value;
      }
      return [value].filter(
        element => element !== undefined && element !== null
      );
    },
  },
  mixins: [userInputMixin],
  props: {
    attribute: {
      required: true,
      type: Object,
    },
  },
  watch: {
    "attribute.fkType": async function () {
      await this.getData();
    },
    "attribute.fkTypeValue": async function () {
      await this.getData();
    },
    "attribute.fkName": async function () {
      await this.getData();
    },
  },
};
</script>
